<template>
  <div class="archives-meeting-row generic-border--card" :class="elClasses">
    <div class="archives-meeting-row__head">
      <span class="archives-meeting-row__name">
        <span class="legend">{{ `${$t('message.NAME')}${$t('message.TWO_DOTS')}` }}</span>
        <span>{{ decodeHTML(meeting.name) }}</span>
      </span>
      <span class="archives-meeting-row__date">{{ date }}</span>
    </div>
    <div class="archives-meeting-row__body">
      <div v-if="infoItems.length === 0">
        {{ $t('message.NO_INFO_AT_DATE') }}
      </div>
      <div v-else>
        <ExpandableSettingsItem :title="$t('message.INFO_AT_DATE', { nb: infoItems.length })" @update="expandChange">
          <InformationItem
            v-for="info in infoItems"
            :key="info.id"
            :value="info"
            class="generic-border--thin-border"
            min
            disabled
            @chipClick="$emit('chipClick', $event, info)"
          />
        </ExpandableSettingsItem>
      </div>
    </div>
  </div>
</template>

<script>

// Vuex
import { FETCH_INFOS } from '@/store/action-types';
// Components
import ExpandableSettingsItem from '@/components/expandable-settings-item.vue';
import InformationItem from '@/components/information-item.vue';
// Utils
import { decodeHTML } from '@/utils/main';

export default {

  name: 'ArchivesMeetingRow',

  components: {
    ExpandableSettingsItem,
    InformationItem,
  },

  props: {
    meeting: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isInfoExpanded: false,
    };
  },

  computed: {
    /** Displayed date */
    date() {
      return this.$moment(this.meeting.date).format(this.$t('dateFormat'));
    },
    /** Date used for state and PHP params */
    paramsDate() {
      return this.$moment(this.meeting.date).format('YYYY-MM-DD');
    },
    /** Fetched information from state */
    infoData() {
      return this.$store.state.infoAtDate[this.paramsDate];
    },
    /** Information item from infoData */
    infoItems() {
      if (this.infoData) {
        const { infos, sentInfos } = this.infoData;
        const newIds = infos.map(i => i.id);
        return infos.concat(sentInfos.filter(i => !newIds.includes(i.id)));
      }
      return [];
    },
    /** Object: Classes applied to this.$el */
    elClasses() {
      return {
        'archives-meeting-row--as-info': this.infoItems.length > 0,
        'archives-meeting-row--as-info-expanded': this.isInfoExpanded,
      };
    },
  },

  created() {
    if (!this.infoData || !this.infoData.loading) {
      this.$store.dispatch(FETCH_INFOS, { date: this.paramsDate });
    }
  },

  methods: {
    decodeHTML,
    expandChange(content) {
      this.isInfoExpanded = content.expanded;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.archives-meeting-row {
  width: 100%;
  margin-top: 0.7rem;
  padding: 1rem;
  border-radius: $main-border-radius;
  box-sizing: border-box;
  transition: padding .3s;
  cursor: initial;

  &:hover {
    background: #fff;
  }

  &--as-info:not(.archives-meeting-row--as-info-expanded) {
    padding-bottom: 0px;
  }

  &__head {
    display: flex;
    justify-content: space-between;
  }

  &__name {
    margin-right: 0.7rem;
  }

  &__body {

    .information-item {
      margin-top: 5px;

      &::after {
        display: none;
      }
    }

    .expandable-settings-item__title {
      height: auto;
      padding-left: 0px;

      .icon {
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
